import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { MessageService } from 'primeng/api';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { JwtInterceptor } from './@core/interceptors/jwt.interceptor';
import { ErrorInterceptor } from './@core/interceptors/error.interceptor';
import { provideMarkdown } from 'ngx-markdown';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import {
  provideTanStackQuery,
  QueryClient,
} from '@tanstack/angular-query-experimental'
import { withDevtools } from '@tanstack/angular-query-experimental/devtools'
import { environment } from '../environments/environment.dev';
import { provideIcons } from '@ng-icons/core';
import { APP_LUCIDE_ICONS } from './@core/components/spartan/icon/icon-registry';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideIcons(APP_LUCIDE_ICONS),
    provideAnimations(),
    MessageService,
    provideMarkdown(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false || 'none'
        }
      }
    }),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        JwtInterceptor,
        ErrorInterceptor,
      ])
    ),
    provideTanStackQuery(
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 0 * 60 * 1000,
            gcTime: 5 * 60 * 1000,
            retry: (failureCount, error: any) => {
              if (error?.status === 404) return false;
              return failureCount < 3;
            },
            refetchOnMount: true,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
          },
          mutations: {
            retry: 1,
          },
        },
      }),
      withDevtools(() => ({ loadDevtools: environment.loadTanStackDevTools }))
    )
  ]
};
